import React, {Component} from 'react';
import './Announcement.css';
import Parser from 'html-to-react';

class AnnouncementItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            announcement: {
                title:null,
                text: null,
                startDate: null,
                endDate: null,
                announcementAttachments:[],
                announcementGroups: [],
                selectedGroups:[],
            }
        };
    }

    componentDidMount() {
        if (this.props.location.selectedAnnouncement!==undefined) {
            this.setState({
                announcement:this.props.location.selectedAnnouncement.announcement
            });
        }
    }

    render() {
        let HtmlToReactParser = Parser.Parser;
        let htmlToReactParser = new HtmlToReactParser();

        return (
            <div className="announcement-block-item-container">
                <div className="col-sm-9">
                    <div className="announcement-title row col-sm-12">{this.state.announcement.title}</div>
                    <br/>
                    <div style={{lineHeight:"30px"}} className="col-sm-12">
                    <div className="announcement-date right row">{new Date(this.state.announcement.startDate).toLocaleDateString('tr') }</div>
                    </div>
                    <br/>
                    <div className="announcement-block-item-content row col-sm-12 ">
                        {htmlToReactParser.parse(this.state.announcement.text)}
                    </div>

                </div>
            </div>
        );
    }
}

export default AnnouncementItem;


// WEBPACK FOOTER //
// ./src/page/announcement/AnnouncementItem.js